import React, { lazy, Suspense } from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
import ModuleLoaderLazy from '../../redux/ModuleLoaderLazy';

const DamzPage = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "damz_shared" */
        './index'
      )
  )
);

export interface Props {
  loadingIndicator?: boolean | React.ReactElement | React.ReactPortal | null;
}

export const DamzPageLoadable: React.FC<Props> = ({ loadingIndicator = null }) => {
  return (
    <ErrorBoundary debugComponent="DamzPageLoadable">
      <Suspense fallback={loadingIndicator || null}>
        <ModuleLoaderLazy />
        <DamzPage />
      </Suspense>
    </ErrorBoundary>
  );
};
DamzPageLoadable.displayName = 'DamzPageLoadable';

export default DamzPageLoadable;
